enum MessageTypes {
  MESSAGES_REQUEST = 'MESSAGES_REQUEST',
  MESSAGES_OPEN = 'MESSAGES_OPEN',
  MESSAGES_CLOSE = 'MESSAGES_CLOSE',
}

export default MessageTypes;
